<template>
	<div class="fullpage-container main">
		<div class="fullpage-wp" v-fullpage="fullpageOption" ref="mainPages">
			<!-- 메인 배너 -->
			<div class="mainBannerPage page">
				<!-- 슬라이드 컴포넌트 -->
				<swiper
					class="mainBanner"
					:auto-update="true"
					:options="swiperOption"
					ref="mainBannerSwiper"
				>
					<!-- slide -->
					<swiper-slide
						class="fullBg banner1"
						v-for="(item, index) in mainTopBanner"
						:key="index"
						:style="{
							backgroundImage:
								'url(' +
								$store.getters.getUrlPrefix +
								bannerImgUrl(item.detail.img) +
								')'
						}"
					>
						<div
							class="bannerFloatWrap"
							:class="[item.detail.theme]"
							:style="{ backgroundColor: item.detail.bgColor }"
							v-if="item.title || item.detail.html || item.detail.link.length"
						>
							<div class="floatContent">
								<h3 v-if="item.title">{{ item.title }}</h3>
								<div
									v-if="item.detail.html"
									class="txt"
									v-html="item.detail.html"
								></div>
								<div v-if="item.detail.link" class="btnWrap aR">
									<template v-for="(linkItem, linkIndex) in item.detail.link">
										<!-- if -->
										<BtnLink
											v-if="!linkItem.txt"
											:key="linkIndex"
											color="rgba(122,122,122,0.8)"
											:router-link="linkItem.url ? linkItem.url : linkItem"
										>
										</BtnLink>
										<!-- else -->
										<b-button
											v-else
											class="recButton"
											:size="$store.state.device === 'mobile' ? 'is-small' : ''"
											:key="linkIndex"
											tag="router-link"
											:to="linkItem.url"
											type="is-primary"
											outlined
											>{{ linkItem.txt }}
										</b-button>
									</template>
								</div>
							</div>
						</div>
					</swiper-slide>
					<!-- Optional controls -->
					<div class="swiper-pagination" slot="pagination"></div>
					<div class="swiper-button-prev" slot="button-prev"></div>
					<div class="swiper-button-next" slot="button-next"></div>
					<!-- <div class="swiper-scrollbar"   slot="scrollbar"></div> -->
				</swiper>
				<router-link class="btnTopBannerFixed contact" to="/cs"
					><p>Contact us</p></router-link
				>
				<!-- <router-link class="btnTopBannerFixed" to="/"><p>Recruit</p></router-link> -->
			</div>

			<!-- solution & service -->
			<SolutionService
				:solution="solution"
				:service="service"
				class="solutionPage page"
			></SolutionService>

			<!-- portfolio -->
			<div class="portfolioPage page">
				<div class="innerPage">
					<div class="topPageTitleWrap">
						<h2>
							Portfolio<BtnLink
								class="btnLink"
								color="#61747B"
								router-link="/portfolio"
							></BtnLink>
						</h2>
						<p class="subText" v-animate="{ value: 'fadeIn' }">We did it.</p>
					</div>
					<swiper
						class="portfolioSlide"
						:options="swiperPortfolioOption"
						ref="myPortfolioSwiper"
					>
						<!-- slides -->
						<swiper-slide
							class="banner2"
							v-for="(item, index) in portfolioList"
							:key="index"
						>
							<div class="portfolioSlideLeft">
								<!-- <h3 :style="{color:item.title.color}">{{item.workTitle}}</h3> -->
								<h3>{{ item.workTitle }}</h3>
								<ul class="portfolioTxtContentList">
									<li class="txtContentItem">
										<span class="tableTitle">Client</span>
										<!-- <span :style="{color:item.client.color}" class="tableTxt client">{{item.client.txt}}</span> -->
										<span class="tableTxt client">{{ item.clientName }}</span>
									</li>
									<li class="txtContentItem">
										<span class="tableTitle">Year</span>
										<!-- <span :style="{color:item.year.color}" class="tableTxt year">{{item.year.txt}}</span> -->
										<span class="tableTxt year">{{ item.year }}</span>
									</li>
									<li class="txtContentItem">
										<span class="tableTitle">Detail</span>
										<!-- <span :style="{color:item.detail.color}" class="tableTxt explanation" v-html="item.detail.html"></span> -->
										<span
											class="tableTxt explanation"
											v-html="item.detail"
										></span>
									</li>
								</ul>

								<!-- <b-button tag="router-link" to="/portfolio" class="btnDetailView" icon-right="arrow-right" size="is-small" rounded inverted>More</b-button> -->
								<b-button
									class="btnDetailView"
									icon-right="arrow-right"
									size="is-small"
									@click="portfolioPopOpen(index)"
									rounded
									inverted
									>자세히 보기</b-button
								>
							</div>
							<div class="portfolioSlideRight">
								<swiper class="innerSwiper" :options="swiperOptionv">
									<swiper-slide
										v-for="(subItem, subIndex) in portfolioImgs(index)"
										:key="'subIdx' + subIndex"
									>
										<div class="imgWrap imgCenter horizontal">
											<img
												v-if="subItem.img"
												:src="$store.getters.getUrlPrefix + subItem.img"
												alt=""
											/>
										</div>
									</swiper-slide>
									<div
										class="swiper-pagination swiper-pagination-v"
										slot="pagination"
									></div>
								</swiper>
							</div>
						</swiper-slide>
						<!-- Optional controls -->
						<div class="swiper-pagination" slot="pagination"></div>
						<div class="swiper-button-prev" slot="button-prev">
							<b-icon
								icon="chevron-left"
								size="is-large"
								type="is-white"
							></b-icon>
						</div>
						<div class="swiper-button-next" slot="button-next">
							<b-icon
								icon="chevron-right"
								size="is-large"
								type="is-white"
							></b-icon>
						</div>
					</swiper>
				</div>
			</div>

			<!-- twosonValuation -->
			<div class="twosonValuationPage page">
				<div class="innerPage">
					<div class="imgWrap imgCenter">
						<img src="@/assets/images/img-main-valuation.png" alt="" />
					</div>
					<div class="textContentWrap">
						<h2>
							<p class="small">Twoson's</p>
							<p>
								Valuation<BtnLink
									class="btnLink"
									color="#A8A8A8"
									router-link="/company"
								></BtnLink>
							</p>
						</h2>
						<p class="subText" v-animate="{ value: 'fadeIn' }">
							함께 걸어가고,<br />성장하고, 도전합니다.<br />전문성과 신뢰를
							쌓고,<br />사회에 나눕니다.
						</p>
					</div>
				</div>
			</div>

			<!-- news & location -->
			<div class="newsLocationPage page">
				<div class="innerPage">
					<div class="newsWrap">
						<h2>News</h2>
						<div class="newsItemWrap">
							<ul class="newsItems">
								<li class="newsItem">
									<router-link to="/news"
										><span class="txt">{{
											this.newsTxt ? this.newsTxt : ""
										}}</span>
										<span class="date">{{
											this.newsLocation.news[0]
												? String(
														this.newsLocation.news[this.newsLocation.newsIndex]
															.registDt
												  ).substr(5, 5)
												: "00-00"
										}}</span></router-link
									>
								</li>
							</ul>
						</div>
						<div class="btnsWrap">
							<button class="btnUp" @click="newsPrev">
								<b-icon
									icon="chevron-up"
									size="is-large"
									type="is-white"
								></b-icon>
							</button>
							<button class="btnDown" @click="newsNext">
								<b-icon
									icon="chevron-down"
									size="is-large"
									type="is-white"
								></b-icon>
							</button>
						</div>
					</div>
					<div class="locationWrap">
						<div
							class="mapWrap"
							:style="{
								backgroundImage:
									'url(' +
									require('@/assets/images/hompage_naver_map.png') +
									')'
							}"
						>
							<!-- <div class="map">
								<img src="@/assets/images/temp-main-map@2x.png" alt="">
							</div> -->
						</div>
						<div class="textContentWrap" v-animate="{ value: 'fadeIn' }">
							<h2>
								Location<!-- <BtnLink class="btnLink" color="#A8A8A8" router-link="/company"></BtnLink> -->
							</h2>
							<div class="subText">
								<span class="txtCode">06141</span>
								<p class="txtAddress">
									서울특별시 강남구<br class="mobileHide" />논현로 94길 28<br />두리빌딩
									5층
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>

		<!-- paging -->
		<div class="fullpagePaging" :class="{ last: this.fullpageIndex == 5 }">
			<b-tooltip
				type="is-dark"
				size="is-small"
				:active="this.$store.state.device != 'mobile'"
				label="Go to top page"
			>
				<button
					class="top"
					v-show="this.fullpageIndex != 0"
					@click="fullpageMove(0)"
				>
					<div>
						Top<b-icon icon="arrow-up" size="is-small" type="is-white"></b-icon>
					</div>
				</button>
			</b-tooltip>
			<b-tooltip
				type="is-dark"
				size="is-small"
				:active="this.$store.state.device != 'mobile'"
				label="Go to Solution &amp; Service"
			>
				<button
					class="dot solutionnservice"
					:class="{ on: this.fullpageIndex == 0 }"
					v-show="this.fullpageIndex != 1"
					@click="fullpageMove(1)"
				>
					<div v-show="this.fullpageIndex == 0 || this.fullpageIndex == 5">
						Solution &amp; Service<b-icon
							icon="arrow-down"
							size="is-small"
							type="is-white"
						></b-icon>
					</div>
				</button>
			</b-tooltip>
			<b-tooltip
				type="is-dark"
				size="is-small"
				:active="this.$store.state.device != 'mobile'"
				label="Go to Portfolio"
			>
				<button
					class="dot portfolio"
					:class="{ on: this.fullpageIndex == 1 }"
					v-show="this.fullpageIndex != 2"
					@click="fullpageMove(2)"
				>
					<div v-show="this.fullpageIndex == 1 || this.fullpageIndex == 5">
						Portfolio<b-icon
							icon="arrow-down"
							size="is-small"
							type="is-white"
						></b-icon>
					</div>
				</button>
			</b-tooltip>
			<b-tooltip
				type="is-dark"
				size="is-small"
				:active="this.$store.state.device != 'mobile'"
				label="Go to Valuation"
			>
				<button
					class="dot valuation"
					:class="{ on: this.fullpageIndex == 2 }"
					v-show="this.fullpageIndex != 3"
					@click="fullpageMove(3)"
				>
					<div v-show="this.fullpageIndex == 2 || this.fullpageIndex == 5">
						Valuation<b-icon
							icon="arrow-down"
							size="is-small"
							type="is-blue"
						></b-icon>
					</div>
				</button>
			</b-tooltip>
			<b-tooltip
				type="is-dark"
				size="is-small"
				:active="this.$store.state.device != 'mobile'"
				label="Go to News &amp; Location"
			>
				<button
					class="dot newsnlocation"
					:class="{ on: this.fullpageIndex == 3 }"
					v-show="this.fullpageIndex != 4"
					@click="fullpageMove(4)"
				>
					<div v-show="this.fullpageIndex == 3 || this.fullpageIndex == 5">
						News &amp; Location<b-icon
							icon="arrow-down"
							size="is-small"
							type="is-white"
						></b-icon>
					</div>
				</button>
			</b-tooltip>
			<b-tooltip
				type="is-dark"
				size="is-small"
				:active="this.$store.state.device != 'mobile'"
				label="Go to Information"
			>
				<button
					class="dot information"
					:class="{ on: this.fullpageIndex == 4 }"
					v-show="this.fullpageIndex != 5"
					@click="fullpageMove(5)"
				>
					<div v-show="this.fullpageIndex == 4 || this.fullpageIndex == 5">
						Information<b-icon
							icon="arrow-down"
							size="is-small"
							type="is-white"
						></b-icon>
					</div>
				</button>
			</b-tooltip>
		</div>
	</div>
</template>

<script>
import { EventBus } from "../utils/event-bus.js";
import BtnLink from "../components/ButtonLinkPage";
import SolutionService from "../views/home/MainSolutionService";
import Footer from "../components/Footer";

export default {
	name: "home",
	components: {
		SolutionService,
		BtnLink,
		Footer
	},
	data() {
		return {
			mainTopBanner: [
				/* {
					bannerNo: 0,
					bannerTurn: 0,
					detail: {
						theme: 'light', // light, dark : 배너 컨텐츠(텍스트 및 버튼)의 배경 및 폰트 색깔을 결정
						bgColor: 'rgba(255,255,255,0.7)', // default:'' - empty / 형식 : #0133af 또는 rgb(255,233,21) 또는 rgba(211,23,0,0.3)
						title: '타이틀',
						html: 'html 텍스트', // html 텍스트
						img: {
							pc: 'image path',
							tablet: 'image path',
							mobile: 'image path'
						},
						link: [
							{ txt: '버튼 이름', url: '/company#partner' }, // txt : '텍스트'인 경우 '텍스트' 이름을 가진 버튼으로 표시
							{ txt: '', url: '링크 url' } // txt가 ''이면 단순 링크아이콘 버튼으로 표시
						]
					}
				}, */
			],
			swiperOption: {
				loop: true,
				speed: 820,
				autoplay: {
					delay: 5000
				},
				mousewheel: false,
				touchStartPreventDefault: false,
				navigation: {
					nextEl: ".mainBannerPage .swiper-button-next",
					prevEl: ".mainBannerPage .swiper-button-prev"
				},
				pagination: {
					el: ".swiper-pagination",
					type: "bullets",
					clickable: true
				}
			},
			fullpageIndex: 0,
			// autoAnime option delete
			fullpageOption: {
				start: 0,
				dir: "v",
				duration: 1500,
				overflow: "auto",
				loop: false,
				beforeChange: function(currentSlideEl, currenIndex, nextIndex) {},
				afterChange: (currentSlideEl, currenIndex) => {
					console.log("fullpage currenIndex:", Number(currenIndex));
					this.fullpageIndex = currenIndex;
					if (this.mainBannerSwiper) {
						if (Number(currenIndex) === 0) {
							// 슬라이드 멈춤
							console.log(">> autoplay start ");
							this.mainBannerSwiper.autoplay.start();
						} else {
							console.log(">> autoplay stop");
							this.mainBannerSwiper.autoplay.stop();
						}
					}
				}
			},
			solution: {},
			service: {},
			portfolioList: [
				/* {
					workTitle: '포트폴리오 (작업) 명',
					clientName: '클라이언트 이름',
					year: '2019',
					detail: '설명 텍스트 (html)', // html text
					mainImg: '', // image path or url
					detailImg: [
						{
							img: '', // image path or url
							link: ''
						},
						{
							img: '', // image path or url
							link: ''
						}
						// ...
					],
					link: '/portfolio'
				} */
			],
			newsLocation: {
				newsIndex: 0,
				news: {},
				location: {}
			},
			swiperPortfolioOption: {
				loop: false,
				effect: "coverflow",
				grabCursor: false,
				centeredSlides: true,
				slidesPerView: "auto",
				spaceBetween: 200,
				touchStartPreventDefault: false,
				coverflowEffect: {
					rotate: -2,
					stretch: 0,
					depth: 100,
					modifier: 2,
					slideShadows: true
				},
				navigation: {
					nextEl: ".portfolioSlide .swiper-button-next",
					prevEl: ".portfolioSlide .swiper-button-prev"
				}
			},
			swiperOptionv: {
				watchOverflow: true,
				loop: false,
				mousewheel: false,
				spaceBetween: 50,
				touchStartPreventDefault: false,
				pagination: {
					el: ".swiper-pagination-v",
					clickable: true
				}
			}
		};
	},
	computed: {
		newsTxt() {
			var newsStr = "";
			if (this.newsLocation.news[this.newsLocation.newsIndex]) {
				newsStr = this.newsLocation.news[this.newsLocation.newsIndex].shortCont;
				newsStr = String(newsStr).replace(/(<([^>]+)>)/gi, "");
			} else {
				newsStr = "뉴스 정보가 로드되지 않았습니다.";
			}
			return newsStr;
		},
		mainBannerSwiper() {
			return this.$refs.mainBannerSwiper.$swiper;
		}
	},
	mounted() {
		// data load
		// Banner data load
		this.$axios
			.post(this.$store.state.dataUrl + "/twosonMainBanner")
			.then(response => {
				console.log("bannerData : ", response.data);
				this.mainTopBanner = response.data;
				this.mainBannerSwiper.init();
			})
			.catch(error => {
				console.log("* bannerData error : ", error.response);
			});
		// portfolio data load
		this.$axios
			.get(this.$store.state.dataUrl + "/twosonPortfolioList?mainShow=true")
			.then(response => {
				console.log("portfolioList : ", response.data);
				this.portfolioList = response.data;
			})
			.catch(error => {
				console.log("* portfolioList error : " + error.response);
			});
		// solution + service data load
		this.$axios
			.post(this.$store.state.dataUrl + "/bannerJsonData")
			.then(response => {
				console.log("solution + service slide : ", response.data);
				this.solution = response.data.solution;
				this.service = response.data.service;
			})
			.catch(error => {
				console.log("* error : " + error.response);
			});
		// board data load
		this.$axios
			.post(this.$store.state.dataUrl + "/twosonBoardList?cate=news&page")
			.then(response => {
				console.log("newsList : ", response.data);
				this.newsLocation.news = response.data;
			})
			.catch(error => {
				console.log("* error : " + error.response);
			});
		document.addEventListener("keydown", this.onkey);
	},
	destroyed() {
		document.removeEventListener("keydown", this.onkey);
	},
	methods: {
		moveNext() {
			this.$refs.mainPages.$fullpage.moveNext(); // Move to the next page
		},
		portfolioImgs(idx) {
			var portfolioListArr;
			if (this.portfolioList[idx]) {
				if (this.portfolioList[idx].mainImg) {
					portfolioListArr = [{ img: this.portfolioList[idx].mainImg }];
				} else {
					return null;
				}
				/* if (this.portfolioList[idx].mainImg) {
					if (this.portfolioList[idx].detailImg) {
						portfolioListArr = [{ img: this.portfolioList[idx].mainImg }].concat(this.portfolioList[idx].detailImg)
					} else {
						portfolioListArr = [{ img: this.portfolioList[idx].mainImg }]
					}
				} else {
					if (this.portfolioList[idx].detailImg) {
						portfolioListArr = this.portfolioList[idx].detailImg
					} else {
						return null
					}
				} */
			}
			return portfolioListArr;
		},
		portfolioPopOpen(idx) {
			EventBus.$emit("portfolio-popup-open", this.portfolioList[idx]);
		},
		fullpageMove(page) {
			console.log("target page", page);
			this.$refs.mainPages.$fullpage.moveTo(page, true);
			this.fullpageIndex = page;
		},
		onkey(event) {
			// console.log(event.keyCode)
			switch (event.keyCode) {
				case 33:
				case 38:
					// pageup
					this.$refs.mainPages.$fullpage.movePrev();
					break;
				case 32:
				case 34:
				case 40:
					// pagedown
					this.$refs.mainPages.$fullpage.moveNext();
					break;
				case 35:
					// end
					this.$refs.mainPages.$fullpage.moveTo(5);
					this.fullpageIndex = 5;
					break;
				case 36:
					// home
					this.$refs.mainPages.$fullpage.moveTo(0);
					this.fullpageIndex = 0;
					break;
				default:
					break;
			}
		},
		bannerImgUrl(elm) {
			var tg = elm;
			var url;
			if (this.$store.state.device === "pc") {
				url = tg.pc;
			} else if (this.$store.state.device === "tablet") {
				url = tg.tablet ? tg.tablet : tg.pc;
			} else if (this.$store.state.device === "mobile") {
				url = tg.mobile ? tg.mobile : tg.pc;
			}
			return url;
		},
		newsNext() {
			if (this.newsLocation.newsIndex === this.newsLocation.news.length) {
				this.newsLocation.newsIndex = 0;
			} else {
				this.newsLocation.newsIndex++;
			}
		},
		newsPrev() {
			if (this.newsLocation.newsIndex === 0) {
				this.newsLocation.newsIndex = this.newsLocation.news.length - 1;
			} else {
				this.newsLocation.newsIndex--;
			}
		}
	}
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

/* page 공통 */
.fullpagePaging {
	position: fixed;
	bottom: 0px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 3;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: center;
	width: fit-content;
	height: auto;
	padding: 3px 0;
	border-top: 1px solid rgba(255, 255, 255, 0.3);
	border-radius: 18px 18px 0 0;
	min-height: 43px;
	background-color: rgba(214, 229, 255, 0.1);
	backdrop-filter: blur(8px);
	box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.12);

	button {
		margin: 2px 5px;
		transition: all 0.35s 0.35s cubic-bezier(0.455, 0, 0.545, 1), padding 0.2s,
			transform 0.2s cubic-bezier(0.455, 0, 0.545, 1);
		transition-timing-function: cubic-bezier(0.455, 0, 0.545, 1);
		font-size: 16px;
		font-weight: bold;
		cursor: pointer;
		box-shadow: 0 3px 3px rgba(0, 0, 0, 0.18);
	}
	.top {
		padding: 4px 12px;
		border-radius: 50px;
		background-color: $c-o-black-50;
		color: $c-white;
		font-size: 14px;
		&.on {
			padding: 7px 28px 7px 34px;
		}
	}
	.dot {
		width: 10px;
		height: 10px;
		border-radius: 50px;
		padding: 0;
		background-color: $c-o-black-50;
		color: $c-white;
		&:hover {
			transform: scale(1.5, 1.5);
		}
		&.on {
			padding: 7px 28px 7px 34px;
			width: auto;
			height: auto;
			background-color: $c-gray-dark;
			transform: scale(1, 1);
			&.solutionnservice {
				background-color: $c-blue-m;
			}
			&.valuation {
				background-color: $c-blue-white;
				color: $c-blue-m;
			}
			&.newsnlocation {
				background-color: $c-blue-gray;
				color: $c-white;
			}
		}
	}
	&.last {
		.top {
			padding: 7px 28px 7px 34px;
			width: auto;
			height: auto;
			background-color: $c-o-black-50;
		}
		.dot {
			padding: 7px 28px 7px 34px;
			width: auto;
			height: auto;
			background-color: $c-o-black-50;
			.icon {
				transform: rotate(180deg) translateY(3px);
			}
			&:hover {
				transform: scale(1, 1);
			}
		}
		.b-tooltip:last-child {
			display: none;
		}
	}
	> span {
		/* ios safari */
		&:first-child {
			margin-left: 6px;
		}
		&:last-child {
			margin-right: 6px;
		}
	}
}
.fullpage-container {
	.page {
		min-height: 400px;
	}
	&.main {
		position: absolute;
		top: 88px;
		left: 0;
		width: 100%;
		height: calc(100% - 88px);
	}
	$pd: 40px;
	.btnTopBannerFixed {
		$w: 110px;
		@include transition(0.3s);
		position: absolute;
		display: flex;
		flex-wrap: wrap;
		align-content: center;
		border: 2px solid rgba(255, 255, 255, 0.3);
		outline: none;
		background-color: rgba(74, 93, 128, 0.12);
		backdrop-filter: blur(3px);
		width: $w;
		height: $w;
		font-size: $text-normal;
		color: $c-white;
		text-align: center;
		z-index: 880;
		&.contact {
			left: $pd;
			bottom: $pd;
			line-height: 1em;
		}
		&:hover {
			background-color: rgba(0, 0, 0, 0.24);
		}
		p {
			position: absolute;
			width: 100%;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}
}
.innerPage .btnLink {
	display: inline-block;
	margin-left: 10px;
	vertical-align: middle;
}
.imgWrap {
	position: relative;
	width: 100%;
	height: 100%;
	pointer-events: none;
	&.imgCenter {
		overflow: hidden;
	}
	img {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100%;
		height: auto;
		max-height: none;
		max-width: 100%;
		transform: translate(-50%, -50%);
	}
	&.horizontal img {
		width: auto;
		height: 100%;
		max-height: 100%;
		max-width: none;
	}
}

/* Main Top Banner */
.mainBannerPage {
	background-color: #fff;
	.swiper-container {
		&.mainBanner {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
		.fullBg {
			background-size: cover;
			background-position: top center;
		}

		.swiper-button-next {
			right: 0;
			&::after {
				margin-right: -2px;
			}
		}
		.swiper-button-prev {
			left: 0;
			&::after {
				margin-left: -2px;
			}
		}
		.swiper-button-next,
		.swiper-button-prev {
			width: 60px;
			height: 60px;
			background-color: rgba(0, 0, 0, 0.12);
			transition: 0.35s background-color;
			&:hover {
				background-color: rgba(0, 0, 0, 0.3);
			}
		}
		.swiper-button-next::after,
		.swiper-button-prev::after {
			color: rgba(255, 255, 255, 0.8);
			font-size: 24px;
			font-weight: bold;
		}

		.swiper-pagination {
			position: absolute;
			text-align: right;
			padding: 0 20px;
			.swiper-pagination-bullet {
				width: 12px;
				height: 4px;
				display: inline-block;
				border-radius: 1px;
				background: #000;
				opacity: 0.2;
				box-shadow: 0 1px 2px rgba(0, 0, 0, 0.24);
				&.swiper-pagination-bullet-active {
					width: 20px;
					opacity: 1;
					background: #ffffff;
				}
			}
		}
	}
	/* 배너용 띄움 내용 */
	.bannerFloatWrap {
		position: absolute;
		right: 3%;
		bottom: 4%;
		/* width: 48%; */
		width: auto;
		min-width: 600px;
		padding: 40px 60px 30px;
		font-size: 26px;
		background-color: rgba(0, 0, 0, 0.61);
		pointer-events: none;
		h3 {
			font-size: 30px;
			color: $c-white;
			margin-bottom: 26px;
			font-weight: normal;
		}
		.txt {
			font-size: 18px;
			color: rgba(255, 255, 255, 0.8);
			margin-bottom: 12px;
		}
		.btnLinkWrap {
			display: inline-block;
			pointer-events: auto;
		}
		.recButton {
			pointer-events: auto;
			margin-right: 4px;
			margin-bottom: 6px;
		}
		&.light {
			background-color: rgba(255, 255, 255, 0.61);
			h3 {
				color: $c-gray-black;
			}
			.txt {
				color: rgba(31, 31, 31, 0.8);
			}
		}
	}
}

/* portfolio */
.portfolioPage {
	background: #000 url("../assets/images/bg-main-portfolio@2x.jpg") top center
		no-repeat;
	background-size: cover;
	.innerPage {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding: 3vh 60px;
		h2 {
			color: $c-white;
			font-size: $title-huge-small;
		}
		.subText {
			color: $c-gray-m;
			font-size: $text-medium;
			max-width: 50%;
			margin-top: -16px;
		}
	}

	.swiper-container {
		// overflow: hidden;
		$pd: 40px;
		&.portfolioSlide {
			position: absolute;
			top: calc(50% - 27vh);
			left: 0;
			width: 100%;
			height: auto;
			& > .swiper-wrapper > .swiper-slide {
				width: 1000px;
				// height: 600px;
				height: 63vh;
				max-height: 600px;
				min-height: 460px;
				background-color: #fff;
				border-radius: 27px;
				box-sizing: border-box;
				padding: $pd;
				overflow: hidden;
				box-shadow: rgba(0, 0, 0, 0.18) 0px 19px 32px;

				.innerSwiper {
					height: 100%;
					.swiper-slide {
						width: 100%;
						height: calc(600px - 80px);
						box-sizing: border-box;
						/* .imgWrap img {
							width: 100%;
							height: auto;
						} */
					}
				}
			}
		}
		.swiper-button-prev {
			left: 50%;
			margin-left: -550px;
			background: none;
		}
		.swiper-button-prev::after {
			content: none;
		}
		.swiper-button-next {
			left: 50%;
			margin-left: 523px;
			background: none;
		}
		.swiper-button-next::after {
			content: none;
		}
		.swiper-button-prev.swiper-button-disabled,
		.swiper-button-next.swiper-button-disabled {
			opacity: 0.12;
		}
		$portfolioLW: 50%;
		$portfolioRW: 100% - $portfolioLW;
		.portfolioSlideLeft {
			width: calc(#{$portfolioLW} - #{$pd + $pd/2});
			position: absolute;
			top: $pd;
			left: $pd;
			height: calc(100% - #{$pd * 2});
			pointer-events: none;
			h3 {
				color: $c-blue-m;
				font-size: $title-small;
				margin-bottom: 40px;
			}
			.txtContentItem {
				display: flex;
				margin-bottom: 20px;
				.tableTitle {
					color: $c-gray-m;
					width: 100px;
				}
				.tableTxt {
					color: $c-gray;
					width: calc(100% - 100px);
					&.client,
					&.year {
						font-weight: bold;
					}
					&.explanation {
						$lh: 24px;
						$lineNum: 9;
						font-size: 15px;
						display: -webkit-box;
						height: $lh * $lineNum - 1px;
						line-height: $lh;
						text-overflow: ellipsis;
						overflow: hidden;
						-webkit-line-clamp: $lineNum;
						-webkit-box-orient: vertical;
					}
				}
			}
			.btnDetailView {
				position: absolute;
				bottom: 0;
				left: 0;
				pointer-events: auto;
			}
		}
		.portfolioSlideRight {
			width: calc(#{$portfolioRW} - #{$pd});
			position: absolute;
			top: $pd;
			right: $pd;
			height: calc(100% - #{$pd * 2});
		}
	}
}

/* twosonValuation */
.twosonValuationPage {
	$leftPer: 68%;
	$rightPer: 100% - $leftPer;
	$pd-inner: 80px;
	background: #000 url("../assets/images/bg-main-valuation@2x.jpg") top center
		no-repeat;
	background-size: cover;
	.innerPage {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		.imgWrap {
			position: absolute;
			top: 0;
			left: $pd-inner/2;
			width: $leftPer;
			height: 100%;
			img {
				width: 90%;
			}
		}
		.textContentWrap {
			position: absolute;
			top: 0;
			right: 0;
			width: $rightPer;
			height: 100%;
			text-align: right;
			h2 {
				position: absolute;
				top: $pd-inner;
				right: $pd-inner;
				color: $c-white;
				font-size: $title-huge;
				.small {
					font-size: $title-huge-small;
					color: $c-gray-light;
				}
			}
			.subText {
				position: absolute;
				bottom: $pd-inner;
				right: $pd-inner;
				min-width: 400px;
				color: $c-white;
				font-size: $text-big;
				text-decoration: underline;
				text-decoration-style: dotted;
				text-decoration-color: rgba(255, 255, 255, 0.5);
				line-height: 60px;
			}
		}
	}
}

/* newsLocationPage */
.newsLocationPage {
	$leftPer: 75%;
	$rightPer: 100% - $leftPer;
	$newsH: 118px;
	.innerPage {
		$pd-inner: 60px;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		.newsWrap {
			position: relative;
			background-color: $c-blue-gray;
			height: $newsH;
			h2 {
				position: absolute;
				top: 14px;
				left: $pd-inner;
				color: $c-white;
				font-size: $title-huge;
			}
			.newsItemWrap {
				position: absolute;
				top: 42px;
				left: $pd-inner + 220px;
				height: 44px;
				width: calc(100% - 320px);
				font-size: $text-medium;
				color: $c-white;
				.newsItems {
					overflow: hidden;
					color: $c-gray-light;
					.newsItem {
						a {
							color: inherit;
						}
						.txt {
							display: inline-block;
							width: calc(100% - 140px);
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							vertical-align: middle;
						}
						.date {
							color: $c-gray-light2;
							margin-left: 20px;
							vertical-align: middle;
						}
					}
				}
			}
			.btnsWrap {
				.btnUp,
				.btnDown {
					position: absolute;
					right: 0;
					width: 59px;
					height: 59px;
					outline: none;
					border: none;
					background-color: $c-blue-dgray;
					opacity: 0.6;
					&:hover {
						opacity: 1;
					}
				}
				.btnUp {
					top: 0;
				}
				.btnDown {
					bottom: 0;
				}
			}
		}
		.locationWrap {
			position: absolute;
			background-color: $c-white;
			top: $newsH;
			left: 0;
			width: 100%;
			height: calc(100% - #{$newsH});
			.mapWrap {
				position: absolute;
				top: 0;
				left: 0;
				width: $leftPer;
				height: 100%;
				background-position: center center;
				background-size: cover;
			}
			.textContentWrap {
				position: absolute;
				top: 0;
				right: 0;
				width: $rightPer;
				height: 100%;
				text-align: right;
				h2 {
					position: absolute;
					bottom: $pd-inner;
					right: $pd-inner;
					color: $c-blue-m;
					font-size: $title-huge;
					width: calc(100% - 120px);
				}
				.subText {
					position: absolute;
					top: $pd-inner;
					right: $pd-inner;
					min-width: 200px;
					color: $c-gray;
					font-size: $text-medium;
					line-height: 36px;
					.txtCode {
						color: $c-gray-light2;
					}
				}
			}
		}
	}
}

/*
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/
@media (max-width: 1280px) and (min-width: 1025px) {
	//CSS
	.newsLocationPage {
		$leftPer: 75%;
		$rightPer: 100% - $leftPer;
		$newsH: 106px;
		.innerPage {
			$pd-inner: 25px;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			.newsWrap {
				position: relative;
				background-color: $c-blue-gray;
				height: $newsH;
				h2 {
					top: 22px;
					left: $pd-inner * 2;
					font-size: $title-medium;
				}
				.newsItemWrap {
					top: 40px;
					left: $pd-inner * 2 + 160px;
					height: 44px;
					width: calc(100% - 240px);
					font-size: $text-normal;
					.newsItems {
						.newsItem {
							.date {
								margin-left: 20px;
							}
						}
					}
				}
				.btnsWrap {
					.btnUp,
					.btnDown {
						right: 0;
						width: $newsH/2;
						height: $newsH/2;
					}
				}
			}
			.locationWrap {
				background-color: $c-white;
				top: $newsH;
				left: 0;
				width: 100%;
				height: calc(100% - #{$newsH});
				.mapWrap {
					top: 0;
					left: 0;
					width: $leftPer;
					height: 100%;
				}
				.textContentWrap {
					top: 0;
					right: 0;
					width: $rightPer;
					height: 100%;
					text-align: right;
					h2 {
						bottom: $pd-inner;
						right: $pd-inner;
						font-size: $title-medium;
						width: calc(100% - #{$pd-inner * 2});
						font-weight: bold;
					}
					.subText {
						top: $pd-inner;
						right: auto;
						left: $pd-inner;
						min-width: auto;
						font-size: $text-normal;
						line-height: 24px;
						text-align: left;
						.txtCode {
							color: $c-gray-light2;
						}
					}
				}
			}
		}
	}
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/
@media (max-width: 1024px) and (min-width: 768px) {
	//css
	.fullpagePaging {
		padding: 2px 0;
		border-radius: 20px 20px 0 0;
		min-height: 36px;
		button {
			margin: 2px;
			font-size: 14px;
		}
		.top {
			padding: 2px 6px;
			border-radius: 50px;
			&.on {
				padding: 5px 18px 5px 24px;
			}
		}
		.dot {
			width: 9px;
			height: 9px;
			&:hover {
				transform: scale(1.3, 1.3);
			}
			&.on {
				padding: 5px 18px 5px 24px;
			}
		}
		&.last {
			.top {
				padding: 5px 18px 5px 24px;
			}
			.dot {
				padding: 5px 18px 5px 24px;
			}
		}
		> span {
			&:first-child {
				margin-left: 4px;
			}
			&:last-child {
				margin-right: 4px;
			}
		}
	}
	.fullpage-container {
		&.main {
			top: 88px;
			height: calc(100% - 88px);
		}
		$pd: 20px;
		.btnTopBannerFixed {
			left: $pd;
			bottom: $pd;
			border: 1px solid rgba(255, 255, 255, 0.3);
			outline: none;
			width: 63px;
			height: 63px;
			font-size: $text-small;
		}
	}
	.mainBannerPage {
		.swiper-container {
			.swiper-button-next,
			.swiper-button-prev {
				width: 32px;
				height: 40px;
				background-color: rgba(0, 0, 0, 0.24);
			}
			.swiper-button-next::after,
			.swiper-button-prev::after {
				color: rgba(255, 255, 255, 0.8);
				font-size: 18px;
			}

			.swiper-pagination {
				padding: 0 20px;
				.swiper-pagination-bullet {
					width: 12px;
					height: 4px;
					border-radius: 1px;
					&.swiper-pagination-bullet-active {
						width: 20px;
					}
				}
			}
		}
		.bannerFloatWrap {
			position: absolute;
			right: 20px;
			bottom: 40px;
			width: 50%;
			min-width: 180px;
			padding: 20px 30px 30px;
			font-size: 24px;
			h3 {
				font-size: 20px;
				margin-bottom: 13px;
				line-height: 1.2em;
			}
			.txt {
				$lh: 1.2em;
				$lineNum: 3;
				font-size: 0.65em;
				margin-bottom: 6px;
				display: -webkit-box;
				height: $lh * $lineNum - 0.02em;
				line-height: $lh;
				text-overflow: ellipsis;
				overflow: hidden;
				-webkit-line-clamp: $lineNum;
				-webkit-box-orient: vertical;
			}
			.btnLinkWrap {
				width: 40px;
				height: 40px;
			}
		}
	}
	.portfolioPage {
		.innerPage {
			padding: 40px;
			h2 {
				font-size: $title-large;
			}
			.subText {
				font-size: $text-normal;
				max-width: 50%;
			}
		}
		.swiper-container {
			$pd: 30px;
			$slideW: 660px;
			$slideH: 400px;
			&.portfolioSlide {
				position: absolute;
				top: calc(50% - 130px);
				left: 0;
				width: 100%;
				height: auto;
				& > .swiper-wrapper > .swiper-slide {
					width: $slideW;
					height: $slideH;
					padding: $pd;
					min-height: unset;

					.innerSwiper {
						height: 100%;
						.swiper-slide {
							width: 100%;
							height: calc(#{$slideH} - 80px);
							box-sizing: border-box;
							/* .imgWrap img {
								width: 100%;
								height: auto;
							} */
						}
					}
				}
			}
			.swiper-button-prev {
				margin-left: #{-$slideW/2 - 48px -10px};
			}
			.swiper-button-next {
				margin-left: #{$slideW/2 + 10px};
			}
			$portfolioLW: 50%;
			$portfolioRW: 100% - $portfolioLW;
			.portfolioSlideLeft {
				width: calc(#{$portfolioLW} - #{$pd + $pd/2});
				top: $pd;
				left: $pd;
				height: calc(100% - #{$pd * 2});
				h3 {
					color: $c-blue-m;
					font-size: $title-small;
					margin-bottom: 30px;
					line-height: 1.1em;
				}
				.txtContentItem {
					margin-bottom: 8px;
					.tableTitle {
						width: 76px;
					}
					.tableTxt {
						font-size: $text-tiny;
						&.client,
						&.year {
							font-weight: bold;
						}
						&.explanation {
							width: 100%;
							$lh: 18px;
							$lineNum: 7;
							display: -webkit-box;
							height: $lh * $lineNum - 1px;
							line-height: $lh;
							text-overflow: ellipsis;
							overflow: hidden;
							-webkit-line-clamp: $lineNum;
							-webkit-box-orient: vertical;
						}
					}
				}
				.btnDetailView {
					position: absolute;
					bottom: 0;
					left: 0;
				}
			}
			.portfolioSlideRight {
				width: calc(#{$portfolioRW} - #{$pd});
				position: absolute;
				top: $pd;
				right: $pd;
				height: calc(100% - #{$pd * 2});
			}
		}
	}
	.twosonValuationPage {
		.innerPage {
			.imgWrap {
				width: 65%;
				img {
					width: 90%;
				}
			}
			.textContentWrap {
				$pd-inner: 60px;
				width: 39%;
				h2 {
					position: absolute;
					top: $pd-inner;
					right: $pd-inner;
					font-size: $title-medium;
					.small {
						font-size: $title-medium-small;
					}
				}
				.subText {
					bottom: $pd-inner;
					right: $pd-inner;
					min-width: auto;
					font-size: $text-medium;
					line-height: 50px;
				}
			}
		}
	}
	.newsLocationPage {
		$leftPer: 75%;
		$rightPer: 100% - $leftPer;
		$newsH: 106px;
		.innerPage {
			$pd-inner: 25px;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			.newsWrap {
				position: relative;
				background-color: $c-blue-gray;
				height: $newsH;
				h2 {
					top: 22px;
					left: $pd-inner * 2;
					font-size: $title-medium;
				}
				.newsItemWrap {
					top: 46px;
					left: $pd-inner * 2 + 160px;
					height: 44px;
					width: calc(100% - 320px);
					font-size: $text-small;
					.newsItems {
						.newsItem {
							.date {
								margin-left: 20px;
							}
						}
					}
				}
				.btnsWrap {
					.btnUp,
					.btnDown {
						right: 0;
						width: $newsH/2;
						height: $newsH/2;
					}
				}
			}
			.locationWrap {
				background-color: $c-white;
				top: $newsH;
				left: 0;
				width: 100%;
				height: calc(100% - #{$newsH});
				.mapWrap {
					top: 0;
					left: 0;
					width: $leftPer;
					height: 100%;
				}
				.textContentWrap {
					top: 0;
					right: 0;
					width: $rightPer;
					height: 100%;
					text-align: right;
					h2 {
						bottom: $pd-inner;
						right: $pd-inner;
						font-size: $title-small;
						width: calc(100% - #{$pd-inner * 2});
						font-weight: bold;
					}
					.subText {
						top: $pd-inner;
						right: auto;
						left: $pd-inner;
						min-width: auto;
						font-size: $text-small;
						line-height: 24px;
						text-align: left;
						.txtCode {
							color: $c-gray-light2;
						}
					}
				}
			}
		}
	}
}

/*
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/
@media (max-width: 1024px) and (min-width: 768px) and (orientation: landscape) {
	//CSS
}

/*
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/
@media (max-width: 767px) and (min-width: 481px) {
	//CSS
	.fullpagePaging {
		padding: 2px 0;
		border-radius: 14px 14px 0 0;
		min-height: 36px;
		button {
			margin: 2px;
			font-size: 14px;
		}
		.top {
			padding: 2px 6px;
			border-radius: 50px;
			&.on {
				padding: 5px 18px 5px 24px;
			}
		}
		.dot {
			width: 9px;
			height: 9px;
			&:hover {
				transform: scale(1.3, 1.3);
			}
			&.on {
				padding: 5px 18px 5px 24px;
			}
		}
		&.last {
			width: calc(100% - 20px);
			.top {
				padding: 5px 18px 5px 24px;
			}
			.dot {
				padding: 5px 18px 5px 24px;
			}
		}
		> span {
			&:first-child {
				margin-left: 4px;
			}
			&:last-child {
				margin-right: 4px;
			}
		}
	}
	.fullpage-container {
		&.main {
			top: 53px;
			height: calc(100% - 53px);
		}
		$pd: 20px;
		.btnTopBannerFixed {
			left: $pd;
			bottom: $pd;
			border: 1px solid rgba(255, 255, 255, 0.3);
			outline: none;
			width: 63px;
			height: 63px;
			font-size: $text-tiny;
			p {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
	.mainBannerPage {
		.swiper-container {
			.swiper-button-next,
			.swiper-button-prev {
				width: 24px;
				height: 40px;
				background-color: rgba(0, 0, 0, 0.24);
			}
			.swiper-button-next::after,
			.swiper-button-prev::after {
				color: rgba(255, 255, 255, 0.8);
				font-size: 16px;
			}

			.swiper-pagination {
				display: none;
			}
		}
		.bannerFloatWrap {
			position: absolute;
			right: 0;
			bottom: 0;
			/* width: 48%; */
			width: 100%;
			min-width: 180px;
			padding: 20px 30px 30px;
			font-size: 24px;
			h3 {
				font-size: 20px;
				margin-bottom: 13px;
				line-height: 1.2em;
			}
			.txt {
				$lh: 1.2em;
				$lineNum: 3;
				font-size: 0.65em;
				margin-bottom: 6px;
				display: -webkit-box;
				height: $lh * $lineNum - 0.02em;
				line-height: $lh;
				text-overflow: ellipsis;
				overflow: hidden;
				-webkit-line-clamp: $lineNum;
				-webkit-box-orient: vertical;
			}
			.btnLinkWrap {
				width: 40px;
				height: 40px;
			}
		}
	}
	.portfolioPage {
		$pd: 20px;
		.innerPage {
			padding: $pd;
			h2 {
				font-size: $title-normal-small;
				line-height: 1em;
			}
			.btnLink {
				width: 24px;
				height: 24px;
				margin-left: 6px;
				a {
					padding: 10px;
				}
			}
			.subText {
				font-size: $text-small;
				max-width: 100%;
				margin-top: -2px;
			}
		}
		.swiper-container {
			$slideW: 300px;
			$slideH: 356px;
			$mgTopBtm: 150px;
			&.portfolioSlide {
				position: absolute;
				top: 50%;
				left: 0;
				transform: translateY(-50%);
				margin-top: 30px;
				width: 100%;
				height: calc(100% - #{$mgTopBtm});
				min-height: $slideH;
				& > .swiper-wrapper > .swiper-slide {
					width: $slideW;
					height: 100%;
					min-height: $slideH;
					padding: $pd;

					.innerSwiper {
						height: 100%;
						.swiper-slide {
							width: 100%;
							height: 100%;
							box-sizing: border-box;
							.imgWrap {
								background-color: $c-gray-light;
								img {
									width: auto;
									height: 100%;
								}
							}
						}
					}
				}
			}
			.swiper-button-prev {
				left: 5px;
				margin-left: 0;
				.icon.is-large {
					width: 100%;
				}
			}
			.swiper-button-next {
				right: 5px;
				left: auto;
				margin-left: 0;
				.icon.is-large {
					width: 100%;
				}
			}
			$portfolioLW: 50%;
			$portfolioRW: 100% - $portfolioLW;
			$txtWrapH: 170px;
			.portfolioSlideLeft {
				width: calc(100% - #{$pd * 2});
				top: calc(46% + #{$pd});
				left: $pd;
				height: calc(56% - 50px);
				h3 {
					font-size: $title-tiny;
					margin-bottom: 8px;
					line-height: 1em;
				}
				.txtContentItem {
					margin-bottom: 6px;
					.tableTitle {
						font-size: $text-xtiny;
						width: 54px;
					}
					.tableTxt {
						font-size: $text-xtiny;
						&.explanation {
							height: 2.4em;
							line-height: 1.2em;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}
						&.client,
						&.year {
							font-weight: bold;
						}
					}
				}
				.btnDetailView {
					position: absolute;
					bottom: 0;
					left: auto;
					right: 0;
				}
			}
			.portfolioSlideRight {
				width: calc(100% - #{$pd * 2});
				position: absolute;
				top: $pd;
				right: $pd;
				height: calc(47% - #{$pd});
			}
		}
	}
	.twosonValuationPage {
		.innerPage {
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.12);
			.imgWrap {
				top: 20px;
				left: 50%;
				transform: translateX(-50%);
				width: 100%;
				max-width: 600px;
				height: 40%;
				img {
					width: 90%;
				}
			}
			.textContentWrap {
				$pd-inner: 40px;
				top: auto;
				bottom: 20px;
				right: 0;
				width: 100%;
				height: 60%;
				text-align: left;
				padding: $pd-inner;
				h2 {
					position: relative;
					top: auto;
					right: auto;
					font-size: $title-small;
					margin-bottom: 10px;
					text-shadow: 0 2px 3px rgba(0, 0, 0, 0.21);
					.small {
						font-size: $title-normal-small;
					}
					.btnLinkWrap {
						width: 40px;
						height: 40px;
					}
				}
				.subText {
					position: relative;
					bottom: auto;
					top: auto;
					right: auto;
					min-width: auto;
					font-size: $text-tiny;
					line-height: 30px;
				}
			}
		}
	}
	.newsLocationPage {
		$leftPer: 75%;
		$rightPer: 100% - $leftPer;
		$newsH: 100px;
		.innerPage {
			$pd-inner: 24px;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			.newsWrap {
				$btnsW: $newsH/2;
				position: relative;
				height: $newsH;
				h2 {
					position: relative;
					padding: 10px $pd-inner 5px;
					top: auto;
					left: auto;
					font-size: $title-xsmall;
				}
				.newsItemWrap {
					position: relative;
					top: auto;
					left: auto;
					height: 44px;
					width: calc(100% - #{$btnsW + $pd-inner});
					padding: 0 0 0 $pd-inner;
					font-size: $text-tiny;
					.newsItems {
						.newsItem {
							.txt {
								float: left;
								width: calc(80% - 10px);
							}
							.date {
								float: right;
								width: 20%;
								margin-left: 0;
								text-align: right;
							}
						}
					}
				}
				.btnsWrap {
					.btnUp,
					.btnDown {
						right: 0;
						width: $newsH/2;
						height: $newsH/2;
					}
				}
			}
			.locationWrap {
				position: absolute;
				background-color: $c-white;
				top: $newsH;
				left: 0;
				width: 100%;
				height: calc(100% - #{$newsH});
				.mapWrap {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				.textContentWrap {
					position: absolute;
					top: 0;
					right: 15%;
					width: 70%;
					height: auto;
					text-align: left;
					background-color: $c-white;
					padding: 10px $pd-inner;
					z-index: 1;
					h2 {
						position: relative;
						bottom: auto;
						right: auto;
						font-size: $title-small;
						width: 100%;
						font-weight: bold;
						margin-bottom: 5px;
					}
					.subText {
						position: initial;
						top: auto;
						right: auto;
						min-width: auto;
						font-size: $text-xtiny;
						line-height: 20px;
						.txtCode {
							display: block;
							position: absolute;
							top: 15px;
							right: $pd-inner;
						}
					}
				}
			}
		}
	}
}

/*
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/
@media (max-width: 480px) and (min-width: $mnWMobile) {
	//CSS
	.fullpagePaging {
		padding: 2px 0;
		border-radius: 14px 14px 0 0;
		min-height: 36px;
		button {
			margin: 2px;
			font-size: 14px;
		}
		.top {
			padding: 2px 6px;
			border-radius: 50px;
			&.on {
				padding: 5px 18px 5px 24px;
			}
		}
		.dot {
			width: 9px;
			height: 9px;
			&:hover {
				transform: scale(1.3, 1.3);
			}
			&.on {
				padding: 5px 18px 5px 24px;
			}
		}
		&.last {
			width: calc(100% - 20px);
			.top {
				padding: 5px 10px 5px 14px;
			}
			.dot {
				padding: 5px 10px 5px 14px;
			}
		}
		> span {
			&:first-child {
				margin-left: 4px;
			}
			&:last-child {
				margin-right: 4px;
			}
		}
	}
	.fullpage-container {
		&.main {
			top: 53px;
			height: calc(100% - 53px);
		}
		$pd: 20px;
		.btnTopBannerFixed {
			&.contact {
				top: $pd;
				bottom: auto;
				left: $pd;
			}
			border: 1px solid rgba(255, 255, 255, 0.3);
			outline: none;
			width: 63px;
			height: 63px;
			font-size: $text-tiny;
			background-color: rgba(74, 93, 128, 0.12);
			backdrop-filter: blur(3px);
			p {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
	.mainBannerPage {
		.swiper-container {
			.swiper-button-next,
			.swiper-button-prev {
				width: 24px;
				height: 40px;
				background-color: rgba(0, 0, 0, 0.24);
			}
			.swiper-button-next::after,
			.swiper-button-prev::after {
				color: rgba(255, 255, 255, 0.8);
				font-size: 16px;
			}

			.swiper-pagination {
				display: none;
			}
		}
		.bannerFloatWrap {
			position: absolute;
			right: 0;
			bottom: 0;
			/* width: 48%; */
			width: 100%;
			min-width: 180px;
			padding: 20px 30px 30px;
			/* font-size: 24px; */
			h3 {
				font-size: 20px;
				margin-bottom: 13px;
				line-height: 1.2em;
			}
			.txt {
				$lh: 16px;
				$lineNum: 3;
				font-size: 16px;
				margin-bottom: 8px;
				display: -webkit-box;
				height: $lh * $lineNum - 1px;
				line-height: $lh;
				text-overflow: ellipsis;
				overflow: hidden;
				-webkit-line-clamp: $lineNum;
				-webkit-box-orient: vertical;
			}
			.btnLinkWrap {
				width: 40px;
				height: 40px;
			}
		}
	}
	.portfolioPage {
		$pd: 20px;
		.innerPage {
			padding: $pd;
			h2 {
				font-size: $title-normal-small;
				line-height: 1em;
			}
			.btnLink {
				width: 24px;
				height: 24px;
				margin-left: 6px;
				a {
					padding: 10px;
				}
			}
			.subText {
				font-size: $text-small;
				max-width: 100%;
				margin-top: -2px;
			}
		}
		.swiper-container {
			$slideW: 300px;
			$slideH: 315px;
			$mgTopBtm: 307px;
			&.portfolioSlide {
				position: absolute;
				top: 50%;
				left: 0;
				transform: translateY(-50%);
				margin-top: 20px;
				width: 100%;
				height: calc(100% - #{$mgTopBtm});
				min-height: $slideH;
				& > .swiper-wrapper > .swiper-slide {
					width: $slideW;
					height: 78%;
					min-height: $slideH;
					padding: $pd;

					.innerSwiper {
						height: 100%;
						border-radius: 6px 6px 0 0;
						.swiper-slide {
							width: 100%;
							height: 100%;
							box-sizing: border-box;
							.imgWrap {
								background-color: $c-gray-light;
								img {
									width: 100%;
									height: fit-content;
								}
							}
						}
					}
				}
			}
			.swiper-button-prev {
				left: 5px;
				margin-left: 0;
				.icon.is-large {
					width: 100%;
				}
			}
			.swiper-button-next {
				right: 5px;
				left: auto;
				margin-left: 0;
				.icon.is-large {
					width: 100%;
				}
			}
			$portfolioLW: 50%;
			$portfolioRW: 100% - $portfolioLW;
			$txtWrapH: 170px;
			.portfolioSlideLeft {
				top: calc(54% + #{$pd});
				left: $pd;
				width: calc(100% - #{$pd * 2});
				height: calc(46% - #{$pd * 2});
				h3 {
					line-height: 1em;
					margin-bottom: 8px;
					letter-spacing: $lspace-short;
					font-size: $title-xxsmall;
					font-weight: bold;
				}
				.txtContentItem {
					margin-bottom: 6px;
					&:nth-last-child(2) {
						position: absolute;
						top: -164%;
						z-index: 9;
						.tableTitle {
							display: none;
						}
						.tableTxt {
							color: $c-white;
							&.year {
								font-size: $text-small;
								font-weight: normal;
								opacity: 0.8;
								text-shadow: 0 1px 2px rgba(0, 0, 0, 0.24);
								white-space: nowrap;
							}
						}
					}
					&:last-child {
						display: none;
					}
					.tableTitle {
						display: none;
					}
					.tableTxt {
						font-size: $text-small;
						&.explanation {
							height: 2.4em;
							line-height: 1.2em;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}
						&.client {
							font-weight: normal;
						}
					}
				}
				.btnDetailView {
					position: absolute;
					bottom: 0;
					left: auto;
					right: 0;
				}
			}
			.portfolioSlideRight {
				position: absolute;
				top: 0;
				right: 0;
				width: 100%;
				height: 54%;
			}
		}
	}
	.twosonValuationPage {
		.innerPage {
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.12);
			.imgWrap {
				top: 0;
				left: 0;
				width: 100%;
				height: 40%;
				img {
					width: 90%;
				}
			}
			.textContentWrap {
				$pd-inner: 40px;
				top: auto;
				bottom: 20px;
				right: 0;
				width: 100%;
				height: 60%;
				text-align: left;
				padding: $pd-inner;
				h2 {
					position: relative;
					top: auto;
					right: auto;
					font-size: $title-small;
					margin-bottom: 10px;
					text-shadow: 0 2px 3px rgba(0, 0, 0, 0.21);
					.small {
						font-size: $title-normal-small;
					}
					.btnLinkWrap {
						width: 40px;
						height: 40px;
					}
				}
				.subText {
					position: relative;
					bottom: auto;
					top: auto;
					right: auto;
					min-width: auto;
					font-size: $text-tiny;
					line-height: 30px;
				}
			}
		}
	}
	.newsLocationPage {
		$leftPer: 75%;
		$rightPer: 100% - $leftPer;
		$newsH: 100px;
		.innerPage {
			$pd-inner: 24px;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			.newsWrap {
				$btnsW: $newsH/2;
				position: relative;
				height: $newsH;
				h2 {
					position: relative;
					padding: 10px $pd-inner 5px;
					top: auto;
					left: auto;
					font-size: $title-xsmall;
				}
				.newsItemWrap {
					position: relative;
					top: auto;
					left: auto;
					height: 44px;
					width: calc(100% - #{$btnsW + $pd-inner});
					padding: 0 0 0 $pd-inner;
					font-size: $text-tiny;
					.newsItems {
						.newsItem {
							.txt {
								float: left;
								width: calc(80% - 10px);
							}
							.date {
								float: right;
								width: 20%;
								margin-left: 0;
								text-align: right;
							}
						}
					}
				}
				.btnsWrap {
					.btnUp,
					.btnDown {
						right: 0;
						width: $newsH/2;
						height: $newsH/2;
					}
				}
			}
			.locationWrap {
				position: absolute;
				background-color: $c-white;
				top: $newsH;
				left: 0;
				width: 100%;
				height: calc(100% - #{$newsH});
				.mapWrap {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				.textContentWrap {
					position: absolute;
					top: 0;
					right: 15%;
					width: 70%;
					height: auto;
					text-align: left;
					background-color: $c-white;
					padding: 10px $pd-inner;
					z-index: 1;
					h2 {
						position: relative;
						bottom: auto;
						right: auto;
						font-size: $title-small;
						width: 100%;
						font-weight: bold;
						margin-bottom: 5px;
					}
					.subText {
						position: initial;
						top: auto;
						right: auto;
						min-width: auto;
						font-size: $text-xtiny;
						line-height: 20px;
						.txtCode {
							display: block;
							position: absolute;
							top: 15px;
							right: $pd-inner;
						}
					}
				}
			}
		}
	}
}
</style>
